import { Link } from "@inertiajs/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import ContentLayout from "../shared/ContentLayout";
import PreviewableVisitorView from "../../components/PreviewableVisitorView";

export default function AnnouncementShow({
  announcement,
  nextAnnouncement,
  previousAnnouncement,
}: any) {
  const renderBreadcrumbs = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link
              href="/"
              className="link link-primary"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              href="/announcements"
              className="link link-primary"
            >
              Announcements
            </Link>
          </li>
          <li>
            <span>{announcement.title}</span>
          </li>
        </ul>
      </div>

      <div style={{
        display: 'flex',
        gap: '8px',
      }}>
        {previousAnnouncement && (
          <Link
            href={`/announcements/${previousAnnouncement.id}`}
            className="btn btn-outline btn-primary btn-xs"
            title={previousAnnouncement.title}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </Link>
        )}
        {nextAnnouncement && (
          <Link
            href={`/announcements/${nextAnnouncement.id}`}
            className="btn btn-outline btn-primary btn-xs"
            title={nextAnnouncement.title}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        )}
      </div>
    </div>
  );

  const renderFooterNavigation = () => (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        {previousAnnouncement && (
          <Link
            href={`/announcements/${previousAnnouncement.id}`}
            className="btn btn-sm btn-outline btn-primary w-full justify-start"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}>
              <div className="truncate">{previousAnnouncement.title}</div>
            </div>
          </Link>
        )}
      </div>

      <div className="flex items-center justify-center">
        <Link
          href="/announcements"
          className="btn btn-primary btn-sm"
        >
          View All Announcements
        </Link>
      </div>

      <div>
        {nextAnnouncement && (
          <Link
            href={`/announcements/${nextAnnouncement.id}`}
            className="btn btn-sm btn-outline btn-primary w-full justify-end"
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}>
              <div className="truncate">{nextAnnouncement.title}</div>
            </div>
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        )}
      </div>
    </div>
  );

  return (
    <ContentLayout
      breadcrumbs={renderBreadcrumbs()}
      footerNavigation={renderFooterNavigation()}
    >
      <div style={{
        padding: '0 4px',
        maxWidth: '1000px',
      }}>
        <div className="card" style={{ backgroundColor: '#f9fafb', borderRadius: 0 }}>
          <div className="card-body" style={{ padding: '16px' }}>
            <PreviewableVisitorView
              publishable={announcement}
            />
          </div>
        </div>
      </div>
    </ContentLayout>
  );
}